/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles, createStyles, Theme } from "@material-ui/core";
import React from "react";
import {
    IEquipment,
    IPropertyType,
    IPropertyTypeInputs,
    PropertyInputs,
} from "../../../../utils/AnnounceInterfaces";
import { PropertyTextField } from "../PropertyTextField";
import { PropertyService } from "../../services/PropertyService";
import { PropertyTextFieldNumber } from "../PropertyTextFieldNumber";
import { equipmentsDefaultValue } from "../../../../utils/defaultNullValues";
// import AutoCompleteWithChips from '../../../components/OverridingMaterial/AutoCompleteWithChips';
import { useTranslation } from "react-i18next";
import { HotelService } from "../../../Admin/Hotel/services/hotelService";
import { UserContext } from "../../../../contexts/AppContext";
import AutoCompleteSolo from "../../../components/OverridingMaterial/AutoCompleteSolo";
import AutoCompleteHotel from "../../../components/OverridingMaterial/autoCompleteHotel";
// import { ERoles } from "../../../../utils/enum/roles";
// import { StandardTextField } from "../../../Admin/components/StandardTextField";
import { SortArray, useQuery } from "../../../../utils/App";
// import {
//     Checkbox,
//     FormControlLabel,
// } from "@material-ui/core";
import { EquipmentService } from "../../../Admin/Equipments/services/EquipmentService";
import { CheckableTreeItem } from "../../../../utils/checkableTreeItem";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: 14,
            marginTop: 6,
        },
        inputText: {
            marginBottom: 14,
            marginTop: 6,
            textAlign: "left",
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        category: {
            marginTop: 10,
            fontSize: "initial",
        },
    })
);

const propertyService = new PropertyService();
const hotelService = new HotelService();
const equipmentService = new EquipmentService();

export function DetailChambre(props: {
    values: PropertyInputs;
    handleChange: (e: any) => void;
    handleChangePropertyType: (e: any) => void;
    handleChangeCheckedJardin: (e: any) => void;
    propertyTypeValues: IPropertyTypeInputs;
    onChangeMultiSelect: (v: any) => void;
    propertyTypeList: IPropertyType[];
    equipmentsSelected: string[];
    onChangeHotel: (e: any) => void;
    hoteSelected: any;
    hotelList: any;
    typeSelected: any;
    choixHotel: any;
    setEquipments: any;
    equipments: any;
    searchTypeName?: string;
}) {
    const query = useQuery();
    const classes = styles();
    const [equipmentsList, setEquipmentsList] = React.useState<IEquipment[]>(
        equipmentsDefaultValue
    );
    const [filteredPropertyTypeList, setFilteredPropertyTypeList] = React.useState<IPropertyType[]>([]);
    const [loading, setLoading] = React.useState(false);
    const [categorie, setCategorie] = React.useState<any>([]);
    const { t, i18n } = useTranslation();
    const [hotel, setHotel] = React.useState<any>([]);
    const userContext = React.useContext(UserContext);
    const { user, setUser } = userContext;
    const SearchTypeName = props.searchTypeName;

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);


    React.useEffect(() => {
        // Ensure SearchTypeName is a string or provide a default value
        const searchTypeString = SearchTypeName || '';
    
        if (props.propertyTypeList) {
            const filteredList = props.propertyTypeList.filter(
                (type: IPropertyType) =>
                    type.searchType?.name?.toString() === searchTypeString
            );
            setFilteredPropertyTypeList(filteredList);
        }
    }, [props.propertyTypeList, SearchTypeName]);



    React.useEffect(() => {
        equipmentService
            .getAllCategories()
            .then((response) => {
                if (response.success) {
                    setCategorie(response.data);
                    setLoading(false);
                }
            })
            .catch((error) => {
                setLoading(false);
            });
    }, [setLoading, setCategorie]);

    React.useEffect(() => {
        setLoading(true);
        propertyService.getAllEquipments().then((response) => {
            if (response.success) {
                // Filter equipments based on SearchTypeName
                const filteredEquipments = response.data.filter(
                    (equipment: IEquipment) =>
                        equipment.applicableSearchTypes?.includes(SearchTypeName || '')
                );
                setEquipmentsList(filteredEquipments.sort(SortArray));
            } else {
                console.error("Failed to fetch equipments:", response);
            }
            setLoading(false);
        }).catch((err) => {
            console.error("Error fetching equipments:", err);
            setLoading(false);
        });
    }, [SearchTypeName]);



    // Build the equipment list by category
    let tab_eq: any = [];
    categorie?.forEach((catego: any) => {
        let eqmt = equipmentsList?.filter(eq => eq.category?._id === catego._id);
        tab_eq.push({
            categorie: catego.name[i18n.language as 'en' | 'fr'] || "Unknown", // Use optional chaining and fallback to "Unknown"
            equipement: eqmt
        });
    });
    //console.log("tab_eq structure:", tab_eq);


    const handleCheck = (eq: any) => {
        if (props.equipments.find((el: any) => el === eq._id)) {
            props.setEquipments((prev: any) =>
                prev.filter((el: any) => el !== eq._id)
            );
        } else {
            props.setEquipments((prev: any) => [...prev, eq._id]);
        }
    };

    React.useEffect(() => {
        try {
            setLoading(true);
            propertyService
                .getAllEquipments()
                .then((response) => {
                    if (response.success) {
                        setEquipmentsList(response.data);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                });
        } catch (error) {}
    }, [setLoading, setEquipmentsList]);
    React.useEffect(() => {
        hotelService
            .getHotelByUser(user._id)
            .then((response) => {
                if (response.success) {
                    setHotel(response.hotel);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [setLoading, setHotel]);

    const reglement = [
        {
            id: "1",
            name: "fumeur",
            label: t("annonce.labels.fumeur"),
        },
        {
            id: "2",
            name: "non fumeur",
            label: t("annonce.labels.non-fumeur"),
        },
    ];
    const type_de_chambre = [
        {
            id: "1",
            name: "Simple",
            label: "annonce.labels.simple",
        },
        {
            id: "2",
            name: "Double",
            label: "annonce.labels.double",
        },
        {
            id: "3",
            name: "Lits Jumeaux",
            label: "annonce.labels.lits-jumeaux",
        },
        {
            id: "4",
            name: "Lits Double",
            label: "annonce.labels.lit-double",
        },
        {
            id: "5",
            name: "Triple",
            label: "annonce.labels.triple",
        },
        {
            id: "6",
            name: "Quadruple",
            label: "annonce.labels.quadruple",
        },
        {
            id: "7",
            name: "Familiale",
            label: "annonce.labels.familiale",
        },
        {
            id: "8",
            name: "Suite",
            label: "annonce.labels.suite",
        },
        {
            id: "9",
            name: "Appartement",
            label: "annonce.labels.appartement",
        },
        {
            id: "10",
            name: "Dortoir",
            label: "annonce.labels.dortoir",
        },
        {
            id: "7",
            name: "Lit en dortoir",
            label: "annonce.labels.lits-en-dortoir",
        },
    ];

    const labelPropertyType = (SearchTypeName === "cars") ? t('propriete.labels.typeDeVehicule') : t('propriete.labels.typeDePropriete');

    return (
        <Grid container style={{ textAlign: "left" }}>
            {query.get("ajout") === "Hôtel" ||
            query.get("ajout") === "exist" ? (
                props.propertyTypeList.length > 0 && (
                    <PropertyTextField
                        id="propertyType"
                        label={`${t("propriete.labels.typeDePropriete")}  *:`}
                        name="name"
                        value={
                            props.propertyTypeList.filter(
                                (val: any) => val.name === "Hôtel"
                            )[0].name
                        }
                        handleChange={() =>
                            props.handleChangePropertyType(
                                props.propertyTypeList.filter(
                                    (val: any) => val.name === "Hôtel"
                                )[0]._id
                            )
                        }
                    />
                )
            ) : (
                <>
                    <PropertyTextField
                        id="propertyName"
                        label={`${t("propriete.labels.nomDeLAnnonce")} *:`}
                        name="name"
                        value={props.values.name}
                        handleChange={props.handleChange}
                    />
                    <Grid item lg={12} sm={12} xs={12}>
                        <label
                            htmlFor="propertyRoomType"
                            className={classes.inputLabel}
                            style={{ display: "block" }}
                        >
                            {t("annonce.labels.typeDeChambre")} *:
                        </label>
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xs={12}
                        className={classes.inputText}
                    >
                        <AutoCompleteSolo
                            id="propertyRoomType"
                            name="name"
                            selectedValues={props.typeSelected}
                            values={type_de_chambre}
                            onChangeSelect={props.handleChangePropertyType}
                        />
                    </Grid>
                </>
            )}

            {/* {
                query.get('ajout')==="exist" ? <>
                    <Grid item lg={12} sm={12} xs={12}>
                        <label
                            htmlFor="propertyCountry"
                            className={classes.inputLabel}
                            style={{ marginBottom: 16, display: "block" }}
                        >
                            Hôtel:
                        </label>
                    </Grid>
                    <Grid item lg={12} sm={12} xs={12} className={classes.inputText}> 
                        <AutoCompleteHotel id="propertyEquipments" name="name" selectedValues={props.hoteSelected} values={props.hotelList} onChangeSelect={props.onChangeHotel}/>
                    </Grid>
                </>:<></>
            } */}

            <Grid item lg={12} sm={12} xs={12}>
                <label
                    htmlFor="propertyRegulations"
                    className={classes.inputLabel}
                    style={{ display: "block" }}
                >
                    {t("annonce.labels.reglements")} *:
                </label>
            </Grid>
            <Grid item lg={12} sm={12} xs={12} className={classes.inputText}>
                <AutoCompleteHotel
                    id="propertyRegulations"
                    name="name"
                    selectedValues={props.hoteSelected}
                    values={reglement}
                    onChangeSelect={props.onChangeHotel}
                />
            </Grid>

            <PropertyTextFieldNumber
                id="propertyMaximumGuests"
                label={`${t("propriete.labels.nombreMaximumDInvites")} *:`}
                name="maximumGuests"
                value={
                    props.values.maximumGuests === 0
                        ? ""
                        : props.values.maximumGuests
                }
                handleChange={props.handleChange}
                placeholder="0"
            />
            <PropertyTextFieldNumber
                id="propertyRooms"
                label={`${t("propriete.labels.nombreDeChambres")}  *:`}
                name="rooms"
                value={props.values.rooms ?? 0}
                handleChange={props.handleChange}
                placeholder="0"
            />
            <PropertyTextField
                id="propertySurface"
                label={`${t("annonce.labels.superficieDeLaChambre")}  :`}
                name="superficie"
                value={props.values.superficie}
                handleChange={props.handleChange}
            />
            <PropertyTextFieldNumber
                id="propertyBeds"
                label={`${t("propriete.labels.nombreDeLits")}  *:`}
                name="lit"
                value={props.values.lit === 0 ? "" : props.values.lit}
                handleChange={props.handleChange}
                placeholder="0"
            />
            <PropertyTextFieldNumber
                id="propertyBathrooms"
                label={`${t("propriete.labels.nombreDeBathrooms")}  *:`}
                name="bathrooms"
                value={
                    props.values.bathrooms === 0 ? "" : props.values.bathrooms
                }
                handleChange={props.handleChange}
                placeholder="0"
            />
            {/* <PropertyTextFieldNumber
                id="propertyRooms"
                label={`${t('propriete.labels.toilette')}  : `}
                name="toilette"
                value={props.values.toilette}
                handleChange={props.handleChange}
            /> */}

            {/* <Grid item lg={12} sm={12} xs={12}>
                <label
                    htmlFor="propertyEquipments"
                    className={classes.inputLabel}
                >
                   {t('propriete.labels.equipements')} :
                </label>
            </Grid> */}
            <Grid item lg={12} sm={12} xs={12} className={classes.inpuText}>
                {/* <AutoCompleteWithChips id="propertyEquipments" name="name" selectedValues={props.equipmentsSelected} values={equipmentsList} onChangeSelect={props.onChangeMultiSelect}/> */}
                <Grid container>
                    {tab_eq.map((cat: any) => {
                        return (
                            <>
                                <Grid item xs={12} className={classes.category}>
                                    <span>{cat.categorie}</span>
                                </Grid>
                                {cat.equipement.map((eq: any) => {
                                    const equipmentName =
                                        i18n.language === "fr"
                                            ? eq.name.fr
                                            : eq.name.en;

                                    return (
                                        <Grid item lg={4} md={4} sm={4} xs={6}>
                                            <CheckableTreeItem
                                                onChecked={() =>
                                                    handleCheck(eq)
                                                }
                                                checkable
                                                node={{
                                                    label: (
                                                        <span
                                                            style={{
                                                                color: "#999",
                                                                fontSize:
                                                                    "smaller",
                                                            }}
                                                        >
                                                            {equipmentName}
                                                        </span>
                                                    ),
                                                    checked:
                                                        props.equipments.find(
                                                            (el: any) =>
                                                                el === eq._id
                                                        ) !== undefined,
                                                }}
                                            />
                                        </Grid>
                                    );
                                })}
                            </>
                        );
                    })}
                </Grid>
            </Grid>
            {/* <FormControlLabel
            control={
              <Checkbox  onChange={props.handleChangeCheckedJardin}  />
            }
            label={t('detail-annonce.jardinprive')}
          /> */}
        </Grid>
    );
}
